// /addresses/new (004 FR-027–FR-035).
import { AddressFormScreen } from "@/profile/addresses/AddressFormScreen";

export default function NewAddress() {
  return <AddressFormScreen mode="create" />;
}
